import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import DataDrivenLogoColumn from '../../../../components/columns/data-driven-logo-column';
import { useHasShippedFromFulfillmentPlanId } from '../../../../hooks/use-has-shipped-from-fulfillment-plan-id';
import PropTypes from 'prop-types';
import { DashPlaceholder } from '../dash-placeholder';

const getDataDrivenLogoColumnProps = ({ serviceId, sellerServices }) => {
  if (!serviceId) {
    return {
      isEmpty: true,
    };
  }

  const sellerService = sellerServices[serviceId];
  if (!sellerService) {
    return {
      isEmpty: true,
    };
  }

  const { labelProviderId, name } = sellerService;
  const providerId = Number.parseInt(labelProviderId, 10);

  return {
    dataDrivenLogoProps: {
      providerId,
    },
    message: name,
  };
};

export const ServiceColumn = ({ fulfillmentPlanId }) => {
  const { labelConfiguration, externalFulfillmentConfiguration } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );
  const { serviceCollectionGuid, serviceId } = labelConfiguration ?? {};
  const { fulfillmentServiceId } = externalFulfillmentConfiguration ?? {};
  const sellerFulfillmentServices = useSelector(Global.selectSellerFulfillmentServices);
  const { name } = sellerFulfillmentServices.find((s) => s.fulfillmentServiceId === fulfillmentServiceId) ?? {};
  const sellerServices = useSelector(Global.selectSellergetShippingServices);
  const dataDrivenLogoColumnProps = getDataDrivenLogoColumnProps({
    serviceCollectionGuid,
    fulfillmentPlanId,
    serviceId,
    sellerServices,
  });
  const { dataDrivenLogoProps: providerId } = dataDrivenLogoColumnProps;
  const hasShipped = useHasShippedFromFulfillmentPlanId(fulfillmentPlanId);

  if (name) {
    return name;
  }

  if (serviceCollectionGuid && !hasShipped && !providerId) {
    return <DashPlaceholder />;
  }
  return <DataDrivenLogoColumn {...dataDrivenLogoColumnProps} />;
};

ServiceColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
